import { rfqConfirmationHeaderStyles as Styles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";

Styles.printButton = {
    buttonType: "outline",
    variant: "secondary",
    typographyProps: {
        color: "secondary",
    },
};
